export const MAXPAGEWIDTH = 1000;